import { motion } from 'framer-motion';

export default function ContactSection() {
  return (
    <section id="contact" className="py-24 lg:py-32 px-6 lg:px-12 bg-zinc-900 text-white">
      <div className="max-w-4xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <h2
            className="text-5xl sm:text-6xl lg:text-7xl font-light mb-8"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            Let&apos;s Create
            <br />
            Together
          </h2>
          <p className="text-lg lg:text-xl text-zinc-400 font-light mb-12 lg:mb-16 leading-relaxed">
            새로운 프로젝트를 시작할 준비가 되셨나요?
            <br />
            함께 혁신적인 경험을 만들어갑니다
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-16">
            <a
              href="mailto:hello@studio.com"
              className="w-full sm:w-auto bg-white text-zinc-900 px-10 py-4 text-sm uppercase tracking-wider hover:bg-zinc-200 transition-all cursor-pointer whitespace-nowrap"
            >
              hello@studio.com
            </a>
            <a
              href="tel:+821012345678"
              className="w-full sm:w-auto border border-white text-white px-10 py-4 text-sm uppercase tracking-wider hover:bg-white hover:text-zinc-900 transition-all cursor-pointer whitespace-nowrap"
            >
              +82 10 1234 5678
            </a>
          </div>

          <div className="flex justify-center gap-6">
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 flex items-center justify-center border border-white/30 hover:border-white hover:bg-white hover:text-zinc-900 transition-all cursor-pointer"
            >
              <i className="ri-instagram-line text-xl"></i>
            </a>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 flex items-center justify-center border border-white/30 hover:border-white hover:bg-white hover:text-zinc-900 transition-all cursor-pointer"
            >
              <i className="ri-linkedin-line text-xl"></i>
            </a>
            <a
              href="https://behance.net"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 flex items-center justify-center border border-white/30 hover:border-white hover:bg-white hover:text-zinc-900 transition-all cursor-pointer"
            >
              <i className="ri-behance-line text-xl"></i>
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
